<template>
  <div class="teu-container container">
    <AnimeTitle
      :title="$t('teuContainer.title')"
      :secondTitle="
        currentLocale === 'zh' ? '' : $t('teuContainer.secondTitle')
      "
      svgRefValue="teuContainerAnimeTitle"
      class="teu-container-title"
      :computingTitle="$t('teuContainer.computingTitle')"
    />
    <div
      class="teu-container-video"
      data-animation="fade-scale-up"
      data-once="false"
    >
      <CustomVideo
        posterVideoUrl="https://img.aikesaisi.com/lkzh/www/jizhuangxiang-poster.mp4"
        videoUrl="https://img.aikesaisi.com/lkzh/www/jizhuangxiang.mp4"
        :txtInfo="txtInfo"
      />
    </div>
    <GridFrom :list="list" class="teu-container-grid" />
  </div>
</template>
<script>
import CustomVideo from '@/components/CustomVideo/index.vue';
import GridFrom from '@/components/GridFrom/index.vue';
export default {
  components: {
    CustomVideo,
    GridFrom,
  },
  computed: {
    txtInfo() {
      return {
        title: this.$t('teuContainer.txtInfo.title'),
        descr: this.$t('teuContainer.txtInfo.descr'),
      };
    },
    list() {
      return [
        {
          title: this.$t('teuContainer.list.item1.title'),
          descr: this.$t('teuContainer.list.item1.descr'),
          imgUrl: require('@/assets/img/pc/teu-icon1.png'),
        },
        {
          title: this.$t('teuContainer.list.item2.title'),
          descr: this.$t('teuContainer.list.item2.descr'),
          imgUrl: require('@/assets/img/pc/teu-icon2.png'),
        },
        {
          title: this.$t('teuContainer.list.item3.title'),
          descr: this.$t('teuContainer.list.item3.descr'),
          imgUrl: require('@/assets/img/pc/teu-icon3.png'),
        },
        {
          title: this.$t('teuContainer.list.item4.title'),
          descr: this.$t('teuContainer.list.item4.descr'),
          imgUrl: require('@/assets/img/pc/teu-icon4.png'),
        },
      ];
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.teu-container {
  text-align: center;
  padding-top: 120px;
  .teu-container-video {
    margin: 60px 0 30px 0;
    width: 100%;
    height: 675px;
  }
  // GridFrom 子项中不同序号 img 的尺寸（穿透到子组件）
  :deep(.teu-container-grid .grid-from-box_item:nth-child(1) img) {
    width: 80px !important;
    height: 80px !important;
  }
  :deep(.teu-container-grid .grid-from-box_item:nth-child(2) img) {
    width: 74px !important;
    height: 74px !important;
  }
  :deep(.teu-container-grid .grid-from-box_item:nth-child(3) img) {
    width: 80px !important;
    height: 80px !important;
  }
  :deep(.teu-container-grid .grid-from-box_item:nth-child(4) img) {
    width: 70px !important;
    height: 70px !important;
  }
}
</style>
